import * as React from 'react';
import JackpotLayer from './JackpotLayer';
import styles from './JackpotLayerSearch.module.scss';

interface JackpotLayerSearchProps {
  value: number;
  currencySymbol?: string;
}

const GT_JACKPOT_TICKER_TEST_ATTR = 'gt-jackpot_ticker_search';

const JackpotLayerSearch = ({
  value,
  currencySymbol,
}: JackpotLayerSearchProps) => (
  <div className={styles.container} data-testid={GT_JACKPOT_TICKER_TEST_ATTR}>
    <JackpotLayer value={value} currencySymbol={currencySymbol} />
  </div>
);

export default React.memo(JackpotLayerSearch);
